export default __webpack_public_path__ + "static/sorgalu-3becf79306da688525307d9623006019.png";